<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
              pTooltip="Обновить список платежей" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ptable1 [value]="recordsList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="(totalRecords > 10)"
         [totalRecords]="totalRecords"
         [paginator]="(totalRecords > 10)"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} строк"
         sortMode="single"
         sortField="DOCDATE"
         dataKey="DOCID"
         selectionMode="single"
         [(selection)]="selectedRecord"
         (onRowSelect)="onRecentRowSelect($event)"
         rowExpandMode="single"
         [rowHover]="true"
         [resizableColumns]="true"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestoreNew($event)"
         styleClass="p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn pSortableColumn="DOCDATE" style="width: 12rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNAME" style="width: auto">Документ <p-sortIcon field="DOCNAME"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CURCODE" style="width: 12rem !important">Валюта <p-sortIcon field="CURCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CURRATE" style="width: 12rem !important">Курс <p-sortIcon field="CURRATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 12rem !important">Сумма <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDVSUM" style="width: 12rem !important">В валюте <p-sortIcon field="PAYDVSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PPART" style="width: 10rem !important">Доля <p-sortIcon field="PPART"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PVPART" style="width: 10rem !important">Доля в валюте <p-sortIcon field="PVPART"></p-sortIcon></th>
    </tr>

    <tr>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCDATE']" (input)="ptable1.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCNAME']" (input)="ptable1.filter($event.target.value, 'DOCNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CURCODE']" (input)="ptable1.filter($event.target.value, 'CURCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CURRATE']" (input)="ptable1.filter($event.target.value, 'CURRATE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PAYDSUM']" (input)="ptable1.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PAYDVSUM']" (input)="ptable1.filter($event.target.value, 'PAYDVSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PPART']" (input)="ptable1.filter($event.target.value, 'PPART', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PVPART']" (input)="ptable1.filter($event.target.value, 'PVPART', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-recordsList>
    <tr [pSelectableRow]="recordsList">
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', recordsList.DOCTYPE, recordsList.DOCID]">{{recordsList.DOCDATE | date:'dd.MM.yyyy' }}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', recordsList.DOCTYPE, recordsList.DOCID]">{{recordsList.DOCNAME}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/currency-rates']">{{recordsList.CURCODE}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{recordsList.CURRATE | number:'1.4-4' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{recordsList.PAYDSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{recordsList.PAYDVSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{recordsList.PPART | percent:'1.0-1' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{recordsList.PVPART |  percent:'1.0-1' }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td > </td>
      <td > </td>
      <td > </td>
      <td > </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalPayd | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalCurrencyPayd | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{peaceOfCake | percent:'1.0-1'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{peaceOfCurrencyCake | percent:'1.0-1'}}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">
      Всего {{recordsList ? recordsList.length : 0 }} платежей на сумму {{totalPayd | number:'1.2-2'}}.
    </div>

    <div class="grid">
      <div class="col-12"></div>
        <div class="col-6">
          <p>Оплачено в основной в валюте</p>
          <p-progressBar [value]="peaceOfCake*100"></p-progressBar>
        </div>
        <div class="col-6">
          <p>Оплачено в валюте документа</p>
          <p-progressBar [value]="peaceOfCurrencyCake*100" class="p-button-secondary"></p-progressBar>
        </div>
      </div>
</ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">На сегодня документов нет</td>
    </tr>
  </ng-template>
</p-table>
